"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AskBrainResponseHandler = void 0;
const AskBrain_1 = require("../../../api/askBrainTyped/AskBrain");
const ResponseHandler_1 = require("./ResponseHandler");
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
const JsonUtil_1 = require("../../../cutil/JsonUtil");
class AskBrainResponseHandler extends ResponseHandler_1.ResponseHandler {
    async handleFuncDataSource(query, res) {
        let askBrainData = new AskBrain_1.AskBrainData();
        if (res.isEnded) {
            if (res.value instanceof AskBrain_1.AskBrainData) {
                askBrainData = res.value;
            }
            else {
                askBrainData.query = query;
                askBrainData.answer = res.value;
                const sourceReg = /(\{\"sources_data\": \{.*\}\})/g;
                const execArr = sourceReg.exec(res.value);
                if (execArr && !(0, is_blank_1.default)(execArr)) {
                    const sourcesDataJson = JSON.parse(execArr[1]);
                    const sourcesData = JsonUtil_1.JsonUtil.toModelFromType(AskBrain_1.AskBrainData, sourcesDataJson)?.sources_data;
                    askBrainData.sources_data = sourcesData;
                    askBrainData.answer = res.value.replace(execArr[1], "").trim();
                }
            }
        }
        else {
            if (res.value instanceof AskBrain_1.AskBrainData) {
                askBrainData = res.value;
            }
            else {
                askBrainData.query = query;
                askBrainData.answer = res.value.trim();
            }
        }
        return new ResponseHandler_1.TransformResponse(JsonUtil_1.JsonUtil.stringify(askBrainData) || "", res.isEnded);
    }
}
exports.AskBrainResponseHandler = AskBrainResponseHandler;
